import { Box, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

interface ItemProps {
  title: string;
  value?: string;
  secondaryValue?: string;
  secondaryVariant?: Variant;

  onClickText?: (text?: string) => void;
}

const SearchClickItem = (props: ItemProps) => {
  const onTextClick = (text?: string) => {
    if (props.onClickText) {
      props.onClickText(text);
    }
  };
  return (
    <>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
        {props.title}
      </Typography>
      <Box onClick={() => onTextClick(props.value)} id="label1Name-box">
        <Typography variant="body2" id="label1">
          {props.value}
        </Typography>
      </Box>
      {props.secondaryValue && (
        <Box onClick={() => onTextClick(props.secondaryValue)} id="label2-box">
          <Typography
            variant={props?.secondaryVariant || 'body2'}
            sx={{ color: 'text.secondary' }}
            id="senderPhone"
          >
            {props.secondaryValue}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default SearchClickItem;
